import { Component, OnInit } from '@angular/core';
import { BaseWithBundleComponent } from '@app/shared/components/base/base-with-bundle.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { RoutingBtnData } from '@app/shared/models/routing-btn-data';
import { SettingsModuleRoutes } from '@app/modules/settings/settings-routes';
import { Module, Page } from '@app/core/authentication/permission';

@Component({
    selector: 'app-settings-widget',
    templateUrl: './settings-widget.component.html',
    styleUrls: ['./settings-widget.component.scss']
})
export class SettingsWidgetComponent extends BaseWithBundleComponent
                                     implements OnInit {

    public settings: RoutingBtnData[] = [];

    public constructor(protected componentServiceBundle: ComponentServiceBundle) {
        super(componentServiceBundle);
        this._idPrefix = 'settings_widget.';
    }

    public ngOnInit() {
        super.ngOnInit();
        this.settings.push({
            id: 'template_management',
            route: SettingsModuleRoutes.TEMPLATE_MANAGEMENT,
            trans: marker('settings_widget.btn.template_management'),
            order: 0
        });
        this.settings.push({
            id: 'user_management',
            route: SettingsModuleRoutes.USER_MANAGEMENT,
            trans: marker('settings_widget.btn.user_management'),
            order: 1
        });
        this.settings.push({
            id: 'office_management',
            route: SettingsModuleRoutes.OFFICE_MANAGEMENT,
            trans: marker('settings_widget.btn.office_management'),
            order: 2
        });
        this.settings.push({
            id: 'department_management',
            route: SettingsModuleRoutes.DEPARTMENT_MANAGEMENT,
            trans: marker('settings_widget.btn.department_management'),
            order: 3
        });
        this.settings.push({
            id: 'third_party_credentials',
            route: SettingsModuleRoutes.THIRD_PARTY_CREDENTIALS,
            trans: marker('settings_widget.btn.third_party_credentials'),
            order: 4
        });
        this.settings.push({
            id: 'address_book',
            route: SettingsModuleRoutes.ADDRESS_BOOK_MANAGEMENT,
            trans: marker('settings_widget.btn.address_book'),
            order: 5
        });
        if (this.currentUser.isAllowedToOpenPage(Page.PAGE_SETTINGS_DISTRIBUTION_RECIPIENTS)) {
            this.settings.push({
                id: 'recipient_options',
                route: SettingsModuleRoutes.RECIPIENT_OPTIONS,
                trans: marker('settings_widget.btn.recipient_options'),
                order: 6
            });
        }
        this.settings.push({
            id: 'case_number',
            route: SettingsModuleRoutes.CASE_NUMBER_MANAGEMENT,
            trans: marker('settings_widget.btn.case_number'),
            order: 7
        });
        this.settings.push({
            id: 'case_settings',
            route: SettingsModuleRoutes.CASE_SETTINGS_MANAGEMENT,
            trans: marker('settings_widget.btn.case_settings'),
            order: 8
        });
        if (this.currentUser.hasModules(Module.MODULE_WORKFLOW)) {
            this.settings.push({
                id: 'workflow',
                route: SettingsModuleRoutes.WORKFLOW_MANAGEMENT,
                trans: marker('settings_widget.btn.workflow'),
                order: 9
            });
        }
    }

    public routeToSetting(route: string): void {
        this.router.navigateByUrl(`${SettingsModuleRoutes.SETTINGS}/${route}`)
                   .then(() => {
            // Nothing needed
        });
    }
}
